module.exports = __webpack_public_path__ + "img/photo-0043.fb38dfd2.jpg";